<template>
  <div>
    <a-select show-search v-model="model.reference_no" style="width: 100%" :default-active-first-option="false"
      :show-arrow="false" :filter-option="false" :not-found-content="null"
      :placeholder="$t('saleContract.typeToSearch')" :loading="fetchQuotationLoading" @search="handleDriverSearch"
      @select="addItem">
      <a-select-option v-for="c in quotationList" :key="c.value" :value="c.value">
        {{ c.label }}
      </a-select-option>
    </a-select>
    <!-- @dropdownVisibleChange="fetchResource" -->
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'referenceNumber',
  props: ['value'],
  data() {
    return {
      fetchQuotationLoading: false,
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['quotations', 'formViewData']),
    quotationList() {
      if (this.formViewData.quotation) {
        return this.formViewData.quotation.map(el => ({
          value: el.quotation_no,
          label: el.quotation_no + (el.customer ? '|' + el.customer.customer_name : '')
        }))
      }
      return []
    },
    thbRate() {
      let foundFx = this.$store.state.wholesale.saleContract.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (foundFx) {
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }
      return (this.model.fx_rate_thb = 32)
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', [
      'fetchQuotation',
      'getFormViewData'
    ]),
    async fetchResource(search = null) {
      this.fetchQuotationLoading = true
      await this.getFormViewData({
        index: 'quotation',
        params: {
          quotation_search: search
        }
      })
      this.fetchQuotationLoading = false
    },
    addItem(value, options) {
      var quotation = this.formViewData.quotation.find(
        q => q.quotation_no == value
      )

      if (!quotation.details) {
        this.$toasted.error('Quotation no  item detail or it completed')
      }

      this.model.project_name = quotation.project_name
      this.model.customer_id = quotation.customer_id
      this.model.grand_total = quotation.grand_total
      this.model.vat_rate = quotation.vat_rate
      this.model.vat_amount = quotation.vat_amount
      this.model.total_exclude_vat = quotation.total_exclude_vat
      this.model.credit_day = quotation.credit_term
      this.model.payment_expiry_date = moment()
        .add(quotation.credit_term, 'days')
        .format('DD-MM-YYYY')
      this.model.expected_delivery_date = moment()
        .add(7, 'days')
        .format('DD-MM-YYYY')
      this.model.kads = null
      this.model.sc_status_id = 3
      this.model.deposit_amount = 0
      this.model.payment_method_id = null
      this.model.account_name = null
      this.model.account_number = null
      this.model.item_list = []
      quotation.details
        .filter(q => q.quantity - q.quantity_received > 0)
        .forEach(el => {
          this.$store.commit('wholesale/saleContract/SET_PRODUCT', {
            uom_cat_id: el.product.uom_cat_id,
            product_id: el.product_id,
            sale_code: el.sale_code,
            uom_category: el.product.uom_category
          })
          this.model.item_list.push({
            product_id: el.product_id,
            product_name_en: el.product_name_en,
            barcode: el.barcode,
            uom_id: el.uom_id,
            quantity: el.quantity - el.quantity_received,
            unit_price: el.unit_price,
            remarks: el.remarks,
            amount: el.unit_price * (el.quantity - el.quantity_received),
            amount_in_bath: el.unit_price * this.thbRate,
            storage_location: el.storage_name_en,
            balance: 'no refresh'
          })
        })
    },
    handleDriverSearch: debounce(function(value) {
      if (!value) return
      this.fetchResource(value)
    }, 500)
  }
}
</script>
